module.exports = __webpack_public_path__ + "files/659d68d48c3ea6f8e3b1f125e5fae249.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/travel_places-4.png
// module id = 515
// module chunks = 76